/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'logs';
const componentName = 'traffic-logs-type-dropdown';
const prefix = `${moduleName}.${componentName}`;

export const l4LogsLabel = `${prefix}.l4LogsLabel`;
export const l7LogsLabel = `${prefix}.l7LogsLabel`;

export const ENGLISH = {
    [l4LogsLabel]: 'L4 Logs',
    [l7LogsLabel]: 'L7 Logs',
};
